// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"d22d2cec","977":"ab005366"}[chunkId] + ".chunk.js";
};